import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoaderComponent } from "@iiht/components";
import { statusCode } from "../../../constants/apis/apiStatus";
import { authTypes, toasterFlags } from "../../../constants/componentConstants";
import { logoutUser } from "../../../store/actions";
import { toastNotification } from "../../../utils/toast";
import HeaderView from "./headerView";
import { getEnv, getLogoutData } from "../../../utils/genericUtils";
import OidcAuthService from "../../../config/OidcAuthService";
import { localStorageHelper } from "../../../utils";
import { directLoginStorage } from "../../../utils/storageHelper";

const HeaderContainer = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { logoutFailData } = useSelector(({ userAuthentication }) => userAuthentication);

  useEffect(() => {
    if (logoutFailData?.status === statusCode.BadRequest400) {
      setLoading(false);
      toastNotification(toasterFlags.ERROR, logoutFailData?.data);
    }
  }, [logoutFailData]);

  const logOutHandler = () => {
    const authType = localStorageHelper.get("auth_type");
    const wsmAuthType = localStorageHelper.get("wsm_auth_type");

    if (authType === authTypes.azuerAD || wsmAuthType === authTypes.azuerAD || authType === authTypes.localUser || wsmAuthType === authTypes.localUser) {
      const logout = getLogoutData();
      dispatch(logoutUser(logout));
      setLoading(true);
    } else {
      let tenantUrl = localStorageHelper.get("tenantUrl");
      let wsmTenantUrl = localStorageHelper.get("wsmTenantUrl");

      localStorageHelper.clear();
      sessionStorage.clear();
      directLoginStorage.clear();

      tenantUrl && window?.location?.replace(`${getEnv()}${tenantUrl}`);
      wsmTenantUrl && window?.location?.replace(`${wsmTenantUrl}`);

      // new OidcAuthService(url).startLogOut();
    }
  };

  return <>{loading ? <LoaderComponent spinning isBackdrop /> : <HeaderView logOutHandler={logOutHandler} />}</>;
};

export default HeaderContainer;
